// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__2kFVW","form":"styles_form__1SQZe"};